<template>
  <el-dialog title="拼团推广"
             :visible.sync="dialogFormVisible"
             :close-on-click-modal="false"
             width="440px"
             @close="emitClose">
    <!-- 切换按钮 -->
    <div class="switch-container">
      <el-radio-group v-model="linkType"
                      @change="handleLinkTypeChange"
                      size="small">
        <el-radio-button label="h5">网页拼团</el-radio-button>
        <el-radio-button label="miniprogram">小程序拼团</el-radio-button>
        <el-radio-button label="webGroup">网页开团</el-radio-button>
        <el-radio-button label="miniprogramGroup">小程序开团</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 模板1：H5链接 / 小程序二维码 -->
    <div class="bcg-container"
         v-if="content.product && (linkType=='h5' || linkType=='miniprogram')">
      <img :src="content.product.picture_url"
           alt=""
           srcset=""
           class="product_img">
      <div class="price-wrap">
        <div class="wrap-left">
          <span class="left-span-1">拼团价: ¥{{content.prices.length?getMinPrice(content.prices):0}}</span>
          <span class="left-span-2">￥{{content.product.price}}元</span>
        </div>
        <div class="wrap-right">
          <span>{{user_count}}人团</span>
        </div>
      </div>
      <div class="product-name">
        {{content.product.name}}
      </div>
      <!-- H5模式：显示二维码div，由qrcodejs2生成 -->
      <div class="qrcode-img"
           id="qrcode1"
           ref="qrcode1"
           v-if="linkType=='h5'"></div>
      <!-- 小程序模式：直接显示接口返回的二维码图片 -->
      <img v-if="linkType=='miniprogram' && miniprogram_url"
           :src="miniprogram_url"
           class="qrcode-img"
           style="object-fit: contain;" />
    </div>

    <!-- 模板2：网页开团 / 小程序开团 -->
    <div class="bcg-container2"
         v-if="content.product && (linkType=='webGroup' || linkType=='miniprogramGroup')">
      <div class="title">大家来一起拼团学习吧</div>
      <div class="white-bg">
        <div class="black">“还差 <span class="red">{{ this.user_count - 1 }}</span>人即可成团，</div>
        <div class="black">我在这等你~” </div>
        <div class="group-info">
          <img :src="content.product.picture_url"
               alt=""
               srcset=""
               class="product_img">
          <div>
            <div class="product-name">{{content.product.name}}</div>
            <div class="wrap-left">
              <span class="left-span-1">拼团价: ¥{{content.prices.length?getMinPrice(content.prices):0}}</span>
              <span class="left-span-2">￥{{content.product.price}}元</span>
            </div>
          </div>
        </div>
        <div class="info-bottom">
          <!-- 网页开团模式：显示二维码div，由qrcodejs2生成 -->
          <div class="qrcode-img"
               id="qrcode2"
               ref="qrcode2"
               v-if="linkType=='webGroup'"></div>
          <!-- 小程序开团模式：直接显示接口返回的二维码图片 -->
          <img v-if="linkType=='miniprogramGroup' && miniprogram_url"
               :src="miniprogram_url"
               class="qrcode-img"
               style="object-fit: contain;" />
          <div>
            <div class="gray-big">长按与好友一起拼团</div>
            <div class="gray-small">分享自「研盒」{{ this.linkType=='miniprogramGroup'?'小程序':'网页' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="down-div">
      <el-link type="primary"
               :underline="false"
               @click="draw">下载图片</el-link>
      <el-link type="primary"
               :underline="false"
               @click="downloadQrcode">下载二维码</el-link>
      <el-link type="primary"
               :underline="false"
               @click="resetGroup"
               v-if="linkType=='webGroup'||linkType=='miniprogramGroup'">重开新团</el-link>
    </div>
    <div style="margin-top: 15px;">
      <el-input placeholder="请输入内容"
                v-model="currentUrl"
                class="input-with-select"
                readonly>
        <el-button slot="append"
                   type="primary"
                   @click="copyUrl">复制链接</el-button>
      </el-input>
    </div>

    <div class="content_container">
      <vue-canvas-poster :painting="painting"
                         @success="success"
                         @fail="fail"></vue-canvas-poster>
    </div>
  </el-dialog>
</template>

<script>
import {
  activityOne,
  getGenerateShareGroupId,
  getShareGroupLink,
} from '@/api/operation'
import { crmUrl } from '@/utils/helper.js'
import QRCode from 'qrcodejs2'

export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    id: {
      type: Number,
      default: () => {
        return 0
      },
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      posterImg: '',
      painting: {},
      product_url: '', // H5链接
      webGroup_url: '', // 网页开团链接
      miniprogram_url: '', // 小程序二维码图片地址
      currentUrl: '',
      user_count: 0,
      linkType: 'h5',
      qrcodeInstance1: null, // 模板1二维码实例
      qrcodeInstance2: null, // 模板2二维码实例
      shareGroupId: 0,
      miniGroupLink: '',
      qrCodeReqSeq: 0, // 小程序码请求序号，用于丢弃过期请求的返回
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
      if (val) {
        this.fetchActivityDetail()
        this.linkType = 'h5'
      }
    },
    content(val) {
      if (val && val.product) {
        this.initUrls()
      }
    },
    linkType(val) {
      if (val == 'webGroup' || val == 'miniprogramGroup') {
        this.fetchGenerateShareGroupId()
      }
      // 获取小程序二维码
      // miniprogramGroup 下 shareGroupId 未就绪时不请求，
      // 由 shareGroupId watcher 在团ID就绪后统一触发，避免 id=0 的无效请求
      if (val !== 'miniprogramGroup' || this.shareGroupId) {
        this.fetchMiniprogramQRCode()
      }
      this.$nextTick(() => {
        this.initPainting()
      })
    },
    miniprogram_url(val) {
      if (
        val &&
        (this.linkType === 'miniprogram' ||
          this.linkType === 'miniprogramGroup')
      ) {
        this.$nextTick(() => {
          this.initPainting()
        })
      }
    },
    shareGroupId(val) {
      this.webGroup_url = `https://h5.kaoyanbox.com/activity/group/${val}`
      console.log('----diaoyong')
      if (this.linkType == 'miniprogramGroup') {
        this.fetchShareGroupLink()
      } else {
        this.updateCurrentUrl()
      }
      this.$nextTick(() => {
        this.generateQRCodeByType()
        this.fetchMiniprogramQRCode()
      })
    },
  },
  methods: {
    getMinPrice(priceArr) {
      const minPrice = priceArr.reduce((min, current) => {
        return current.price < min ? current.price : min
      }, priceArr[0].price)
      return minPrice
    },
    async resetGroup() {
      if (
        this.linkType !== 'webGroup' &&
        this.linkType !== 'miniprogramGroup'
      ) {
        return
      }

      // 调用接口生成新团ID
      let param
      if (this.content.prices && this.content.prices.length > 0) {
        param = {
          activity_id: this.id,
          sku_id: this.content.prices[0].sku_id,
          direct_new_status: 1,
        }
      } else {
        param = { activity_id: this.id, direct_new_status: 1 }
      }

      try {
        const res = await getGenerateShareGroupId(param)
        this.shareGroupId = res.share_group_id

        // 重新获取小程序链接（如果是小程序开团模式）
        if (this.linkType === 'miniprogramGroup') {
          await this.fetchShareGroupLink()
        }

        // 更新网页开团链接
        this.webGroup_url = `https://h5.kaoyanbox.com/activity/group/${this.shareGroupId}`

        // 更新当前显示的链接
        this.updateCurrentUrl()

        // 重新生成二维码
        this.$nextTick(() => {
          this.generateQRCodeByType()
          this.fetchMiniprogramQRCode()
          this.initPainting()
        })

        this.$notify.success({
          title: '提示',
          message: '已生成新团，二维码和链接已更新',
        })
      } catch (error) {
        console.error('重开新团失败:', error)
        this.$notify.error({
          title: '提示',
          message: '重开新团失败，请稍后重试',
        })
      }
    },
    async initUrls() {
      const productType = this.content.product.type
      const productId = this.content.product_id

      // H5链接（模板1）
      if (productType == 1) {
        this.product_url = `https://h5.kaoyanbox.com/course/detail/${productId}`
      } else if (productType == 4) {
        this.product_url = `https://h5.kaoyanbox.com/material/detail/${productId}`
      } else if (productType == 3) {
        this.product_url = `https://h5.kaoyanbox.com/read/detail/${productId}`
      }
      this.currentUrl = this.product_url
      // this.$nextTick(() => {
      //   this.generateQRCodeByType()
      // })
      this.generateQRCodeByType(() => {
        this.initPainting()
      })
    },

    // 根据当前类型生成二维码
    generateQRCodeByType(callback) {
      if (this.linkType === 'h5') {
        this.generateQRCode('qrcode1', this.product_url, 'h5', callback)
      } else if (this.linkType === 'webGroup') {
        this.generateQRCode('qrcode2', this.webGroup_url, 'webGroup', callback)
      } else if (callback) {
        callback()
      }
    },

    // 生成二维码（使用qrcodejs2）
    generateQRCode(elementId, url, type, callback) {
      if (!url) {
        console.warn(`${type} 链接为空`)
        return
      }

      let instance = type === 'h5' ? this.qrcodeInstance1 : this.qrcodeInstance2
      if (instance) {
        const qrcodeDiv = document.getElementById(elementId)
        if (qrcodeDiv) {
          qrcodeDiv.innerHTML = ''
        }
        instance = null
      }
      this.$nextTick(() => {
        instance = new QRCode(elementId, {
          width: type === 'h5' ? 88 : 54,
          height: type === 'h5' ? 88 : 54,
          text: url,
        })

        if (type === 'h5') {
          this.qrcodeInstance1 = instance
        } else {
          this.qrcodeInstance2 = instance
        }
        setTimeout(() => {
          if (callback) callback()
        }, 200)
      })
    },

    // 获取小程序二维码
    async fetchMiniprogramQRCode() {
      let miniprogram_path = ''
      if (this.linkType == 'miniprogram') {
        const productType = this.content.product.type
        const productId = this.content.product_id

        if (productType == 1) {
          miniprogram_path = `/graduatA/courseDetail/courseDetail?id=${productId}`
        } else if (productType == 3) {
          miniprogram_path = `/graduatA/datum/detail?id=${productId}`
        } else if (productType == 4) {
          miniprogram_path = ``
        }
      } else if (this.linkType == 'miniprogramGroup') {
        // 团ID未就绪时直接跳过，杜绝 id=0 的无效请求
        // （待 fetchGenerateShareGroupId 返回后由 shareGroupId watcher 统一触发）
        if (!this.shareGroupId) {
          console.warn('shareGroupId 未就绪，跳过小程序开团码请求')
          return
        }
        miniprogram_path = `/graduatA/groupDetail/groupDetail?id=${this.shareGroupId}`
      }

      if (!miniprogram_path) {
        console.warn('小程序路径为空')
        return
      }

      // 竞态保护：只认最新一次请求的返回，旧请求晚到时直接丢弃
      const seq = ++this.qrCodeReqSeq
      let str = crmUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/wechat/getQRCodeSeniorUnlimited`,
        method: 'post',
        data: { qr_path: miniprogram_path },
        headers: { Authorization: localStorage.getItem('token') },
      })
      if (seq !== this.qrCodeReqSeq) return
      this.miniprogram_url = res.data.data
    },

    // 更新当前显示的链接/文案
    updateCurrentUrl() {
      let miniprogram_path
      const productType = this.content.product.type
      const productId = this.content.product_id

      if (productType == 1) {
        miniprogram_path = `https://senior.kaoyanbox.com/#/graduatA/courseDetail/courseDetail?id=${productId}`
      } else if (productType == 3) {
        miniprogram_path = `https://senior.kaoyanbox.com/#/graduatA/datum/detail?id=${productId}`
      } else if (productType == 4) {
        miniprogram_path = ``
      }
      switch (this.linkType) {
        case 'h5':
          this.currentUrl = this.product_url
          break
        case 'miniprogram':
          this.currentUrl = miniprogram_path
          break
        case 'webGroup':
          this.currentUrl = this.webGroup_url
          break
        case 'miniprogramGroup':
          this.currentUrl = this.miniGroupLink
          break
      }
    },

    handleLinkTypeChange(type) {
      this.updateCurrentUrl()
      this.$nextTick(() => {
        this.generateQRCodeByType()
      })
    },
    fetchGenerateShareGroupId() {
      let param
      if (this.content.prices && this.content.prices.length > 0) {
        param = {
          activity_id: this.id,
          sku_id: this.content.prices[0].sku_id,
        }
      } else {
        param = { activity_id: this.id }
      }
      getGenerateShareGroupId(param).then((res) => {
        this.shareGroupId = res.share_group_id
      })
    },
    fetchShareGroupLink() {
      console.log('----diaoyong')
      let param = {
        link_path: 'graduatA/groupDetail/groupDetail',
        link_query: `id=${this.shareGroupId}`,
      }

      getShareGroupLink(param).then((res) => {
        this.miniGroupLink = res.url_link
        this.updateCurrentUrl()
      })
    },

    fetchActivityDetail() {
      activityOne({ id: this.id }).then((res) => {
        this.user_count = res.user_count
      })
    },

    emitClose() {
      // 清除二维码实例
      if (this.qrcodeInstance1) {
        const qrcodeDiv = document.getElementById('qrcode1')
        if (qrcodeDiv) qrcodeDiv.innerHTML = ''
        this.qrcodeInstance1 = null
      }
      if (this.qrcodeInstance2) {
        const qrcodeDiv = document.getElementById('qrcode2')
        if (qrcodeDiv) qrcodeDiv.innerHTML = ''
        this.qrcodeInstance2 = null
      }
      this.$emit('close')
    },

    downloadQrcode() {
      let imgSrc = ''
      if (this.linkType === 'h5') {
        const img = document.querySelectorAll('#qrcode1 img')
        imgSrc = img.length > 0 ? img[0].src : ''
      } else if (this.linkType === 'webGroup') {
        const img = document.querySelectorAll('#qrcode2 img')
        imgSrc = img.length > 0 ? img[0].src : ''
      } else if (
        this.linkType === 'miniprogram' ||
        this.linkType === 'miniprogramGroup'
      ) {
        imgSrc = this.miniprogram_url
      }

      if (imgSrc) {
        const a = document.createElement('a')
        a.download = `qrcode_${this.linkType}`
        a.href = imgSrc
        a.click()
      } else {
        this.$notify.warning({ title: '提示', message: '二维码未生成' })
      }
    },

    copyUrl() {
      const input = document.createElement('textarea')
      input.value = this.currentUrl
      this.$copyText(input.value).then(() => {
        this.$notify.success({
          title: '提示',
          message: '复制成功',
          type: 'success',
        })
      })
    },

    // draw() {
    //   const a = document.createElement('a')
    //   if (this.linkType == 'webGroup' || this.linkType == 'miniprogramGroup') {
    //     a.download = `[还差${this.user_count - 1}]this.content.product.name`
    //   }
    //   a.download = `poster_${this.linkType}`
    //   a.href = this.posterImg
    //   a.click()
    // },
    draw() {
      const a = document.createElement('a')
      if (this.linkType == 'webGroup' || this.linkType == 'miniprogramGroup') {
        // 开团模式：文件名格式为 "还差X人+商品名称"
        const remainingCount = this.user_count - 1
        const productName = this.content.product.name || '商品'
        a.download = `[还差${remainingCount}人]${productName}.png`
      } else {
        // 非开团模式：保持原有格式
        a.download = `poster_${this.linkType}.png`
      }
      a.href = this.posterImg
      a.click()
    },
    success(src) {
      this.posterImg = src
    },

    fail(err) {
      console.error('海报生成失败:', err)
      this.$notify.error({ title: '错误', message: '海报生成失败' })
    },
    truncateText(text, maxLength) {
      if (!text) return ''
      // 按中文字符计算，一个中文算1个字符
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    },
    // 初始化海报配置
    initPainting() {
      setTimeout(() => {
        let qrcodeImg = ''
        let isTemplate1 =
          this.linkType === 'h5' || this.linkType === 'miniprogram'
        let isTemplate2 =
          this.linkType === 'webGroup' || this.linkType === 'miniprogramGroup'
        const productName = this.content.product?.name || ''

        const truncatedName = this.truncateText(productName, 22)
        // 获取二维码图片
        if (isTemplate1) {
          if (this.linkType === 'h5') {
            const qrcodeElement = document.querySelector('#qrcode1 img')
            qrcodeImg = qrcodeElement ? qrcodeElement.src : ''
          } else {
            qrcodeImg = this.miniprogram_url
          }
          // 模板1配置
          this.painting = {
            width: '400px',
            height: '636px',
            background: require('../../../assets/img/activity_bcg.png'),
            views: [
              {
                type: 'image',
                url: this.content.product.picture_url,
                css: {
                  left: '40px',
                  width: '320px',
                  height: '320px',
                  top: '112px',
                },
              },
              {
                type: 'text',
                text: `拼团价: ¥${
                  this.content.prices.length
                    ? this.getMinPrice(this.content.prices)
                    : 0
                }`,
                css: {
                  width: '195px',
                  fontSize: '20px',
                  color: '#FE1F41',
                  bottom: '165px',
                  left: '40px',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'text',
                text: `￥${this.content.product.price}元`,
                css: {
                  width: '80px',
                  fontSize: '14px',
                  color: '#CCCCCC',
                  bottom: '165px',
                  left: '170px',
                  fontFamily: 'PingFang SC',
                  textDecoration: 'line-through',
                },
              },
              {
                type: 'text',
                text: `${this.user_count}人团`,
                css: {
                  fontSize: '10px',
                  color: '#fff',
                  bottom: '170px',
                  right: '47px',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'text',
                text: this.content.product.name,
                css: {
                  width: '195px',
                  height: '120px',
                  fontSize: '16px',
                  color: '#333',
                  bottom: '85px',
                  left: '40px',
                  fontFamily: 'PingFang SC',
                  lineHeight: '24px',
                  fontWeight: '800',
                },
              },
              {
                type: 'image',
                url: qrcodeImg,
                css: {
                  right: '40px',
                  width: '88px',
                  height: '88px',
                  bottom: '56px',
                },
              },
            ],
          }
        } else if (isTemplate2) {
          if (this.linkType === 'webGroup') {
            const qrcodeElement = document.querySelector('#qrcode2 img')
            qrcodeImg = qrcodeElement ? qrcodeElement.src : ''
          } else {
            qrcodeImg = this.miniprogram_url
          }
          // 模板2配置
          this.painting = {
            width: '310px',
            height: '367px',
            background: require('../../../assets/img/activity_bcg2.png'),
            views: [
              {
                type: 'view',
                css: {
                  top: '52px',
                  left: '14px',
                  width: '282px',
                  height: '290px',
                  background: '#ffffff',
                  borderRadius: '10px',
                },
              },
              {
                type: 'text',
                text: '大家来一起拼团学习吧',
                css: {
                  top: '14px',
                  left: '0',
                  width: '310px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: '#ffffff',
                  textAlign: 'center',
                  fontFamily: 'AlimamaShuHeiTi',
                },
              },
              {
                type: 'text',
                text: `“还差 ${this.user_count - 1} 人即可成团，`,
                css: {
                  top: '73px',
                  left: '14px',
                  width: '282px',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#333333',
                  textAlign: 'center',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'text',
                text: '我在这等你~”',
                css: {
                  top: '97px',
                  left: '14px',
                  width: '282px',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#333333',
                  textAlign: 'center',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'image',
                url: this.content.product.picture_url,
                css: {
                  top: '132px',
                  left: '22px',
                  width: '88px',
                  height: '88px',
                  borderRadius: '8px',
                },
              },
              {
                type: 'text',
                text: truncatedName,
                css: {
                  top: '132px',
                  left: '120px',
                  width: '168px',
                  height: '40px',
                  fontSize: '14px',
                  color: '#333333',
                  lineHeight: '20px',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'text',
                text: `拼团价: ¥${
                  this.content.prices.length
                    ? this.getMinPrice(this.content.prices)
                    : 0
                }`,
                css: {
                  top: '182px',
                  left: '120px',
                  fontSize: '16px',
                  color: '#FE1F41',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'text',
                text: `￥${this.content.product.price}元`,
                css: {
                  top: '185px',
                  left: '229px',
                  fontSize: '12px',
                  color: '#CCCCCC',
                  textDecoration: 'line-through',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'image',
                url: 'https://upload.kaoyanbox.net/1f2c54b1b03af9a3a1ecd4735cf0fd77.png',
                css: {
                  top: '247px',
                  left: '22px',
                  width: '266px',
                  height: '1px',
                },
              },
              {
                type: 'image',
                url: qrcodeImg,
                css: {
                  top: '262px',
                  left: '22px',
                  width: '54px',
                  height: '54px',
                },
              },
              {
                type: 'text',
                text: '长按与好友一起拼团',
                css: {
                  top: '267px',
                  left: '86px',
                  fontSize: '10px',
                  color: '#999999',
                  fontFamily: 'PingFang SC',
                },
              },
              {
                type: 'text',
                text: `分享自「研盒」${
                  this.linkType == 'miniprogramGroup' ? '小程序' : '网页'
                }`,
                css: {
                  top: '287px',
                  left: '86px',
                  fontSize: '8px',
                  color: '#999999',
                  fontFamily: 'PingFang SC',
                },
              },
            ],
          }
        }
        console.log('painting 生成完成', this.painting)
      }, 500)
    },
  },
}
</script>

<style lang="less" scoped>
.switch-container {
  text-align: center;
  margin-bottom: 16px;
  /deep/ .el-radio-button__inner {
    padding: 8px 20px;
  }
}

.bcg-container2 {
  margin: auto;
  width: 310px;
  height: 367px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 14px;
  position: relative;
  background-image: url('https://upload.kaoyanbox.net/a3cb199f0a327d298b788aa00ef2abfa.png');

  .title {
    text-align: center;
    font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    height: 29px;
    line-height: 29px;
  }

  .white-bg {
    margin-top: 14px;
    width: 282px;
    height: 290px;
    border-radius: 10px;
    background: #fff;
    padding: 21px 8px;

    .info-bottom {
      border-top: 1px dashed #ccc;
      padding: 17px 0;
      display: flex;
      align-items: center;

      .qrcode-img {
        width: 54px;
        height: 54px;
        margin-right: 10px;
      }

      .gray-big {
        height: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #999999;
        line-height: 15px;
      }

      .gray-small {
        height: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 8px;
        color: #999999;
        line-height: 15px;
      }
    }

    .black {
      height: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: center;

      .red {
        color: #ff234f;
      }
    }

    .group-info {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .product_img {
        width: 88px;
        height: 88px;
        border-radius: 8px;
        margin-right: 10px;
      }

      .product-name {
        margin-bottom: 17px;
        height: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        // 添加多行文本截断
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 限制显示两行 */
        -webkit-box-orient: vertical;
        word-break: break-all; /* 允许单词内换行 */
      }

      .wrap-left {
        .left-span-1 {
          font-size: 16px;
          color: #fe1f41;
          margin-right: 16px;
        }
        .left-span-2 {
          font-size: 12px;
          color: #cccccc;
          text-decoration: line-through;
        }
      }
    }
  }
}

.bcg-container {
  width: 400px;
  height: 636px;
  background-image: url('https://upload.kaoyanbox.net/e742bf45cc339ebcbb42e3eb63b8a6dc.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 0px 40px;
  padding-top: 100px;
  position: relative;

  .product_img {
    width: 320px;
    height: 320px;
    border-radius: 6px;
    margin-top: 12px;
  }

  .price-wrap {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .wrap-left {
      .left-span-1 {
        font-size: 20px;
        color: #fe1f41;
        margin-right: 16px;
      }
      .left-span-2 {
        font-size: 14px;
        color: #cccccc;
        text-decoration: line-through;
      }
    }

    .wrap-right {
      width: 40px;
      text-align: center;
      span {
        font-size: 10px;
        color: #fff;
      }
    }
  }

  .product-name {
    position: absolute;
    bottom: 95px;
    width: 195px;
    min-height: 60px;
    font-size: 16px;
    font-weight: 800;
    line-height: 24px;
  }

  .qrcode-img {
    position: absolute;
    width: 88px;
    height: 88px;
    bottom: 64px;
    right: 40px;
  }
}

.down-div {
  margin-top: 16px;
  .el-link {
    font-size: 12px;
    margin: 0px 8px;
  }
}
</style>